var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "process-editor-top"
  }, [_c('div', {
    staticClass: "process-name"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getTitle)
    }
  }), _vm.editBtnView && !_vm.readOnly && !_vm.experimentFlag ? _c('button', {
    staticClass: "btn_top",
    on: {
      "click": _vm.titlChangeModal
    }
  }, [_vm._v("수정")]) : _vm._e(), _vm.experimentFlag ? _c('button', {
    staticClass: "btn_basic",
    style: {
      background: _vm.editorLayoutClass == 'layout_type_4' ? 'blanchedalmond' : 'white'
    },
    on: {
      "click": function ($event) {
        return _vm.applyClass('layout_type_4');
      }
    }
  }, [_vm._v("공정도/실험입력값 분할보기")]) : _vm._e(), _vm.experimentFlag ? _c('button', {
    staticClass: "btn_basic",
    style: {
      background: _vm.editorLayoutClass == 'layout_type_2' ? 'blanchedalmond' : 'white'
    },
    on: {
      "click": function ($event) {
        return _vm.applyClass('layout_type_2');
      }
    }
  }, [_vm._v("실험입력값만 보기")]) : _vm._e(), _vm.experimentFlag ? _c('button', {
    staticClass: "btn_basic",
    style: {
      background: _vm.editorLayoutClass == 'layout_type_1' ? 'blanchedalmond' : 'white'
    },
    on: {
      "click": function ($event) {
        return _vm.applyClass('layout_type_1');
      }
    }
  }, [_vm._v("공정도만 보기")]) : _vm._e()]), _c('UserInfomation', {
    attrs: {
      "userName": _vm.userName
    }
  }), _c('Preview', {
    attrs: {
      "process-info": _vm.selectProcessInfo
    },
    on: {
      "setMethod": function ($event) {
        return _vm.getChildMethods('preview', $event);
      },
      "preview-close": _vm.searchPopupShow
    }
  }), _c('ProcessSearch', {
    attrs: {
      "type": _vm.$route.query.editorType
    },
    on: {
      "setMethod": function ($event) {
        return _vm.getChildMethods('search', $event);
      },
      "select-process": _vm.selectProcess,
      "process-preview": _vm.previewClick
    }
  }), _c('MakeProcess', {
    attrs: {
      "active": _vm.titleChange,
      "Type": _vm.checkProjectType,
      "Data": _vm.crntProtocol || _vm.ProcessInfo
    },
    on: {
      "confirm": _vm.modifyTop,
      "close": function ($event) {
        _vm.titleChange = false;
      }
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }